<template>
    <div class="category" v-show="showPlatforms">
        <div class="categoryTitle titleWithExpand" @click="toggleCollapse">
            Platforms Visited in the Last 30 Days
            <button style="cursor: pointer;">
                <svg v-if="!isCollapsed" width="24" height="24">
                    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path>
                </svg>
                <svg v-else width="24" height="24">
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path>
                </svg>
            </button>
        </div>
        <div class="expandableTableRow" :style="currHeight">
            <table class="dynamicTable responsiveTD" style="text-align: left;">
                <thead>
                    <tr>
                        <th scope="col">Platform</th>
                        <th scope="col">Company</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="obj in platforms" :key="obj.platform">
                        <td data-label="Platform">{{obj.platform}}</td>
                        <td data-label="Company" v-if="obj.operator"><router-link :to="{name: 'Operators', params: {operator: obj.operator}}" class="link">{{obj.company}}</router-link></td>
                        <td data-label="Company" v-else>{{obj.company}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'provider-platform-table',
    data: () => ({
        platforms: [],
        showPlatforms: false,
        isCollapsed: false,
        expandableHeight: 0
    }),
    methods: {
        updateInfo: function(platformInfo) {
            var globv = this;
            globv.platforms = platformInfo;
            globv.showPlatforms = globv.platforms.length > 0;
            globv.expandableHeight = globv.platforms.length * 40 + 40 + 24;
        },
        reset: function() {
            var globv = this;
            globv.platforms = [];
        },
        toggleCollapse: function() {
            var globv = this;
            globv.isCollapsed = !globv.isCollapsed;
        },
    },
    computed: {
        currHeight() {
            var globv = this;
            return {
                "max-height": globv.isCollapsed ? "0px" : globv.expandableHeight * 20 + 'px'
            }
        },
    }
}
</script>